import MuiTypography from './components/Typography/index'
import MuiLink from './components/Link'
import MuiInput from './components/Input'
import MuiFormControl from './components/FormControl'
import PreloBold from '../fonts/Prelo/Prelo-Bold/styles.css'
import Prelo from '../fonts/Prelo/Prelo-Medium/styles.css'
import { createTheme } from '@mui/material'

const theme = createTheme({
  palette: {
    primary: {
      light: '#FFFFFF',
      main: '#FFDD00',
      dark: '#FFCC00',
      text: 'var(--greyish-brown)',
      contrastText: '#0F265C'
    },
    secondary: {
      light: '#FFFFFF',
      main: '#ffffff',
      dark: '#0f265c',
      contrastText: '#0F265C'
    },
    error: {
      main: '#ff604f'
    },
    text: {
      secondary: '#0f265c',
      primary: '#4a4a4a'
    }
  },
  shadows: Array(25).fill('none'),
  status: {
    danger: '#FFDD00'
  },
  overrides: {
    MuiCssBaseline: {
      '@global': {
        '@font-face': [Prelo, PreloBold]
      }
    },
    MuiTypography,
    MuiLink,
    MuiInput,
    MuiFormControl
  },
  typography: {
    fontFamily: ['Prelo'].join(',')
  }
})

export default theme
